module.exports = __webpack_public_path__ + "img/symbol_3.24d1ae7c.png";